<template>
  <div id="app">
    <div v-if="showModalFile" id='modal-container' @keyup.esc="showModalFile = false" tabindex="1" >
        <Csv></Csv>
    </div>

    <transition name="show-from-left">
      <popover name="helpskipped" :width="240">
          <Help :titleChart="titleChart"> 
            <div slot="content">
              <p> {{ $t("154") }}</p>
            </div>     
          </Help>
      </popover>
    </transition>

    <div id='buttons-csv' class="btn-group btn-group-sm bt-change-chart" role="group" aria-label="Group Buttons">
        <button type="button" class="btn btn-secondary" @click="getCsvAll()" ><small>{{ $t("145") }}</small></button>
    </div>

    <div class="title-charts">{{ $t("155") }}
      <button class="bt-help" v-popover:helpskipped.right><i class="icon-help ti-help-alt"></i></button>
    </div>

    <highcharts :options="chartOptions" ref='chart'></highcharts>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Vue from 'vue'
import axios from 'axios';
import mixin from '../../../../utils/mixin'

import Popover  from 'vue-js-popover'
Vue.use(Popover)
import Help from 'src/components/Dashboard/Views/components/Help'
import Csv from 'src/components/Dashboard/Views/components/Csv'

export default {
  name: 'charts',
  components: {
    Help,
    Csv
  },
  data () {
    return {
      showModalFile: false,
      titleChart: this.$t("155"),
      tableData: [],
      chartOptions: {
        colors: ['#8b3d88', '#90ed7d', '#e4d354', '#f45b5b', '#6b91c9', '#3e9b80', '#3257a8', '#dd6b7f', '#0984e3', '#ffeaa7', '#e84393', '#55efc4', '#636e72', '#ff7675', '#f1c40f', '#34495e'],
        chart: {
          type: 'pie',
          backgroundColor: 'rgba(0,0,0,0)',
          style: {
            fontFamily: '\'Unica One\', sans-serif'
          },
          plotBorderColor: '#606063',
        },
        title: {
          text: '',
          style: {
            color: '#E0E0E3',
            textTransform: 'uppercase',
            fontSize: '16px',
            fontWeight: 'bold'
          }
        },
        subtitle: {
          text: '',
          style: {
            color: '#E0E0E3',
            textTransform: 'uppercase'
          }
        },
        accessibility: {
          announceNewData: {
            enabled: true
          },
          point: {
            valueSuffix: '%'
          }
        },
        xAxis: {
          gridLineColor: '#707073',
          labels: {
            style: {
              color: '#E0E0E3'
            }
          },
          lineColor: '#707073',
          minorGridLineColor: '#505053',
          tickColor: '#707073',
          title: {
            style: {
              color: '#A0A0A3'
            }
          }
        },
        yAxis: {
          gridLineColor: '#707073',
          labels: {
            style: {
              color: '#E0E0E3'
            }
          },
          lineColor: '#707073',
          minorGridLineColor: '#505053',
          tickColor: '#707073',
          tickWidth: 1,
          title: {
            style: {
              color: '#A0A0A3'
            }
          }
        },
        tooltip: {
          headerFormat: '',
          pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b>',
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          style: {
            color: '#F0F0F0'
          }
        },
        plotOptions: {
          pie: {
            borderWidth: 0, // < set this option
            size: '70%',
            dataLabels: {
              distance: 1
            },
          },
          series: {
              innerSize: '50%',
            dataLabels: {
              enabled: true,
              format: '<span style="color:#fff ">{point.name}:<br></span><span style="color:#fff "> {point.percentage:.1f}%</span>',
              color: '#F0F0F3',
              style: {
                fontSize: '13px'
              }
            },
            marker: {
              lineColor: '#333'
            },
            events:{
              click: this.loadGrid
            },
          },
          boxplot: {
            fillColor: '#505053'
          },
          candlestick: {
            lineColor: 'white'
          },
          errorbar: {
            color: 'white'
          }
        },
        legend: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          itemStyle: {
              color: '#E0E0E3'
          },
          itemHoverStyle: {
              color: '#FFF'
          },
          itemHiddenStyle: {
              color: '#606063'
          },
          title: {
            style: {
              color: '#C0C0C0',
              fontSize: '12px'
            }
          }
        },
        credits: {
          style: {
            color: '#666'
          }
        },
        labels: {
          style: {
            color: '#707073'
          }
        },
        drilldown: {
          activeAxisLabelStyle: {
            color: '#F0F0F3'
          },
          activeDataLabelStyle: {
            color: '#F0F0F3'
          }
        },
        navigation: {
          buttonOptions: {
            symbolStroke: '#DDDDDD',
            theme: {
              fill: '#505053'
            }
          }
        },
        rangeSelector: {
          buttonTheme: {
            fill: '#505053',
            stroke: '#000000',
            style: {
              color: '#CCC'
            },
            states: {
              hover: {
                fill: '#707073',
                stroke: '#000000',
                style: {
                  color: 'white'
                }
              },
              select: {
                fill: '#000003',
                stroke: '#000000',
                style: {
                  color: 'white'
                }
              }
            }
          },
          inputBoxBorderColor: '#505053',
          inputStyle: {
            backgroundColor: '#333',
            color: 'silver'
          },
          labelStyle: {
            color: 'silver'
          }
        },
        navigator: {
          handles: {
            backgroundColor: '#666',
            borderColor: '#AAA'
          },
          outlineColor: '#CCC',
          maskFill: 'rgba(255,255,255,0.1)',
          series: {
            color: '#7798BF',
            lineColor: '#A6C7ED'
          },
          xAxis: {
            gridLineColor: '#505053'
          }
        },
        scrollbar: {
          barBackgroundColor: '#808083',
          barBorderColor: '#808083',
          buttonArrowColor: '#CCC',
          buttonBackgroundColor: '#606063',
          buttonBorderColor: '#606063',
          rifleColor: '#FFF',
          trackBackgroundColor: '#404043',
          trackBorderColor: '#404043'
        },
        series: [
        {
          name: "RGP",
          colorByPoint: true,
          data: []
        }
      ],
      drilldown: {
        series: []
      },
      exporting: { enabled: false },
      credits: {
        enabled: false
      },
      loading: {
          labelStyle: {
              color: 'black',
              textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff',
          },
          style: {
              backgroundColor: 'none',
              opacity: 1,
              marginTop: '20px'
          }
      },

      },//fim chartOptions
    }
  },
  mixins: [mixin],
  methods: {
    ...mapMutations(['changeGrid']),

      loadGrid(event){
        let skipped = event.point.name;
        let point_name = event.point.name;
        let NAME_CHART = this.$t("352") + ' - ' + point_name.toUpperCase() 

        const ENDPOINT = `v1/mysemeq-ambev/get-general-report?year=${this.filters.year}&period=${this.filters.period}&plant=${this.filters.plant}&region=${this.filters.region}&status=4&technique=${this.filters.technique}&skipped=${skipped}&area=${this.filters.area}&sector=${this.filters.sector}&machine=${this.filters.machine}&component=${this.filters.component}`

        let grid = {
          totalDados: event.point.y,
          title: skipped,
          url: ENDPOINT,
          name_chart: NAME_CHART,
          columns: {
            "rows": '',
            "plant": this.$t("310"),
            "area": this.$t("311"),
            "sector": this.$t("312"),
            "component": this.$t("313"),
            "component_tag": this.$t("314"),
            "component_type_en": this.$t("315"),
            "machine": this.$t("316"),
            "machine_tag": this.$t("317"),
            "technique_en": this.$t("321"),
          },
          show: true,
          titleHelp: 'Grid - ' + this.$t("352"),
          txtHelp: this.$t("353")
        }

        if (this.filters.plant) {
          grid.title += ' - ' + this.filters.plant_name
          delete grid.columns['plant']
        } else if (this.filters.region){
          grid.title += ' - ' + this.filters.region
        }

        this.changeGrid(grid);

    },

    getData(){

      const API = process.env.ROOT_API;
      const ENDPOINT = 'v1/mysemeq-ambev/get-skipped-chart'
      let self = this;

      this.$refs.chart.chart.showLoading();

      axios({method: 'GET', url: API + ENDPOINT, params: this.filters, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
      .then(resp => {
        self.tableData = resp.data;        
        self.$refs.chart.chart.hideLoading();
      })
      .catch(err => {
        // from mixin
        self.ApiErrorHandler(self, error.response.data.status_code);
        self.$refs.chart.chart.showLoading('Error');
      })

    },
    setChartData () {
      var self = this
      var res = self.tableData
      var values = []
      for (var key in res) {
        values.push({'name': res[key].status_txt, 'y': res[key].total, 'drilldown': res[key].status })
      }
      self.chartOptions.series[0].data = values
    },
    getCsvAll() {
        let self = this;
        self.showModalFile = true
        var file = 'csv'
        const API = process.env.ROOT_API

        const ENDPOINT = `v1/mysemeq-ambev/get-general-report?year=${this.filters.year}&period=${this.filters.period}&plant=${this.filters.plant}&region=${this.filters.region}&status=4&technique=${this.filters.technique}&skipped=&area=${this.filters.area}&sector=${this.filters.sector}&machine=${this.filters.machine}&component=${this.filters.component}&pg=0&sort=&order=asc&file=`+ file
        
        let name_chart_file = this.$t("352")

        axios({
          method: 'GET', 
          url: API + ENDPOINT, 
          responseType: 'blob',
          headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` 
        }})
        .then(function({ data }){ 
            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', name_chart_file+'.csv');
            document.body.appendChild(link);
            link.click();
            self.showModalFile = false
        })
        .catch(function(error){
            // from mixin
            self.ApiErrorHandler(self, error.response.data.status_code);
        })
    },
  }, 
  computed: {
    ...mapGetters(['filters']),
  },
  watch: {
    filters: function(newValue){
      this.getData();
    },
    tableData: function(){
      this.setChartData();
    }
  }
}
</script>
<style scoped>
tspan {
    /*fill: #fff;*/
    stroke: none!important;
    stroke-width: 1px;
    stroke-linejoin: round;
    /*color: #fff;*/
   /* font-weight: normal;
    font-size: 10px;*/
}
#buttons-csv{
    position: absolute;
    right: 20px;
    top: 0px;
    z-index: 101;
    height: 20px;
    align-items: center;
}
.highcharts-drilldown-data-label text{
  text-decoration:none !important;
}

div[data-popover="helpskipped"] {
  left: 66% !important;
  top: 0% !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Charts/ChartsSkipped.vue